import api from "../../axiosConfig";

export const addDiagnoses = async (formData) => {
    const token= sessionStorage.getItem('token');
    try {

      const response = await api.post('/diagnoses/add-diagnoses', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getDiagnoses = async (searchKeyword,doctor_id) => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('/diagnoses/all-diagnoses', {
      params: {
        search_keyword: searchKeyword,
        doctor_id:doctor_id
      },
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching receptionist');
  }
};

export const updateDiagnoses = async (id, formData) => {
  const token = sessionStorage.getItem('token');

  // Append required format values
  const payload = {
    ...formData,
    id: parseInt(id),
    _method: 'put', // Required for Laravel-style method spoofing
  };
  console.log('Payload for update:', payload);

  try {
    const response = await api.post(`/diagnoses/update-diagnoses/${id}`, payload
    );

    const resData = response?.data;
    console.log('Update receptionist response:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating receptionist');
  }
};
export const deleteDiagnoses = async (id) => {
  try {
    const response = await api.delete(`diagnoses/delete/${id}`);

    const resData = response?.data;
    console.log('Delete diagnoses response:', resData);

    if (resData?.message_type === 'success') {
      return { success: true, data: resData.message };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error deleting medicine');
  }
};